import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  HIDE_MESSAGE,
  SET_CURRENT, SET_CURRENT_DATE,
  SHOW_MESSAGE,
  SET_IMPORT_ERRORS,
  SET_FILE_TO_IMPORT
} from "../../constants/ActionTypes";
import axios from '../../util/Api';

export const fetchStart = () => {
  return {
    type: FETCH_START
  }
};

export const fetchSuccess = () => {
  return {
    type: FETCH_SUCCESS
  }
};

export const fetchError = (error) => {
  return {
    type: FETCH_ERROR,
    payload: error
  }
};

export const showMessage = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  }
};

export const hideMessage = () => {
  return {
    type: HIDE_MESSAGE
  }
};


export const setCurrent = (current) => {
  return {
    type: SET_CURRENT,
    payload: current
  }
}

export const setImportErrors = (errors) => ({
    type: SET_IMPORT_ERRORS,
    payload: errors,
})

export const setFileToImport = (file) => ({
    type: SET_FILE_TO_IMPORT,
    payload: file,
})

export const setCurrentDate = (data) => {
  return {
    type: SET_CURRENT_DATE,
    payload: data
  }
}

export const fetchRecords = (url) => {
  let token = JSON.parse(localStorage.getItem("token"));
  //  axios.defaults.headers.common['Accept'] = "application/json";
  axios.defaults.headers.common['Authorization'] = "Bearer " + token;
  //axios.defaults.headers.common['X-Additional-Auth-Token'] = document.cookie.replace(/(?:(?:^|.*;\s*)additional_auth_token\s*\=\s*([^;]*).*$)|^.*$/, "$1");

  return new Promise((resolve, reject) => {
    axios.get(url).then(({data}) => {
      resolve(data);
    }).catch(err => {
      if (err.response && err.response.status === 401) {
        //history.push('/Home');  // Redirect to the login page
        localStorage.removeItem('token');
        window.location.href = '/Home';
      } else {
          reject(err);
      }
    });
  });
};

export const saveRecords = (url, data) => {
  let token = JSON.parse(localStorage.getItem("token"));
  //  axios.defaults.headers.common['Accept'] = " application/json";
  axios.defaults.headers.common['Authorization'] = "Bearer " + token;
  //axios.defaults.headers.common['X-Additional-Auth-Token'] = document.cookie.replace(/(?:(?:^|.*;\s*)additional_auth_token\s*\=\s*([^;]*).*$)|^.*$/, "$1");

  return new Promise((resolve, reject) => {
    axios.post(url, data).then(({data}) => {

      resolve(data);

    }).catch(err => {
      //reject(err);
      console.log(err);
      if (err.response && err.response.status === 401) {
        //history.push('/Home');  // Redirect to the login page
        localStorage.removeItem('token');
        window.location.href = '/Home';
      } else {
          reject(err);
      }

    });
  });


};

export const updateRecords = (url, data) => {
  let token = JSON.parse(localStorage.getItem("token"));
  axios.defaults.headers.common['Authorization'] = "Bearer " + token;

  return new Promise((resolve, reject) => {
    axios.put(url, data).then(({data}) => {
      resolve(data);
    }).catch(err => {
      console.log(err);
      if (err.response && err.response.status === 401) {
        localStorage.removeItem('token');
        window.location.href = '/Home';
      } else {
        reject(err);
      }
    });
  });
};

export const deleteRecords = (url) => {
  let token = JSON.parse(localStorage.getItem("token"));
  axios.defaults.headers.common['Authorization'] = "Bearer " + token;

  return new Promise((resolve, reject) => {
    axios.delete(url).then(({data}) => {
      resolve(data);
    }).catch(err => {
      console.log(err);
      if (err.response && err.response.status === 401) {
        localStorage.removeItem('token');
        window.location.href = '/Home';
      } else {
        reject(err);
      }
    });
  });
};

export const saveRecordsDownloader = (url, data) => {
  let token = JSON.parse(localStorage.getItem("token"));
  
  axios.defaults.headers.common['Authorization'] = "Bearer " + token;

  return new Promise((resolve, reject) => {
      axios({
          method: 'post',
          url: url,
          data: data,
          responseType: 'blob', // This is important for downloading blobs (binary data)
      })
      .then(response => {
          // Create a URL from the blob and trigger the download
          const blob = new Blob([response.data], { type: response.headers['content-type'] });
          const url = window.URL.createObjectURL(blob);

          // Create an <a> element to programmatically trigger the download
          const link = document.createElement('a');
          link.href = url;

          // Set the filename dynamically if the backend returns one
          const contentDisposition = response.headers['content-disposition'] || '';
          let filename = '';
          if (contentDisposition) {
              // Handles: attachment; filename="foo.xlsx"; filename*=UTF-8''foo.xlsx
              const match = contentDisposition.match(/filename\*?=(?:UTF-8''|"?)([^";]+)"?/i);
              if (match && match[1]) {
                  filename = decodeURIComponent(match[1]);
              }
          }

          if (!filename) {
              const requestedFormat = (data && data.format) ? String(data.format).toLowerCase() : '';
              const contentType = String(response.headers['content-type'] || '').toLowerCase();

              let ext = 'pdf';
              if (requestedFormat === 'xlsx') {
                  ext = 'xlsx';
              } else if (requestedFormat === 'json_download') {
                  ext = 'json';
              } else if (contentType.includes('spreadsheetml') || contentType.includes('ms-excel')) {
                  ext = 'xlsx';
              } else if (contentType.includes('application/json')) {
                  ext = 'json';
              }

              filename = `downloaded_file.${ext}`;
          }

          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();

          // Clean up by removing the element and revoking the URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          // Resolve the promise to indicate success
          resolve(response.data);
      })
      .catch(err => {
          reject(err);
          console.log(err);
      });
  });
};








